import http from "../plugins/axios";

const loadInclusions = async () => {
    const response = await http.get('/api/company/v3/inclusion');
    return response.data;
};

export default {loadInclusions};